import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { RiArrowDownSLine } from "react-icons/ri";
import axios from "axios";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
// import defaultImage from "../../../utils/DefaultImage";
import PaginationComponent from "../../../utils/PaginationComponent";
import TableLoader from "../../../utils/TableLoader";
// import SearchInput from "../../../utils/SearchInput";
// import plus from "../../../assets/admin/plus.svg";
// import plus from "../../../assets/admin/plus.svg";
// import editIcon from "../../../assets/admin/edit.svg";
// import deleteIcon from "../../../assets/admin/delete.svg";
import { FaPlus } from "react-icons/fa";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { BiSolidTrashAlt } from "react-icons/bi";
import OrderView from "./OrderEdit/OrderView";
import OrderAdd from "./OrderEdit/OrderAdd";
import OrderEdit from "./OrderEdit/OrderEdit";

const OrderManagement = (props, ref) => {
    const { rest_slug2 } = useParams();
    const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;
    const token = localStorage.getItem("token");
    const [isLoading, setIsLoading] = useState(false);
    const [showOrder, setShowOrder] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState();
    const [openDropdownId, setOpenDropdownId] = useState(null);

    const [orderData, setOrderData] = useState([]);
    const [viewOrderData, setViewOrderData] = useState({});

    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    //================= create order ================================
    const [IsAddOrder, setIsAddOrder] = useState(false);

    const [dialog, setDialog] = useState(false);
    const [selectedOrderId, setSelectedOrderId] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [currentOrderData, setCurrentOrderData] = useState(null);

    const [selectedStatus, setSelectedStatus] = useState("In Attesa");
    const [selectedStatus1, setSelectedStatus1] = useState("");
    const [userType, setUserType] = useState('');
    // const statuses = ["Pending", "Accepted", "Rejected"];

    // const statuses = [
    //     { label: "In Attesa", value: "Pending" },
    //     { label: "Accettato", value: "Accepted" },
    //     { label: "Respinto", value: "Rejected" }
    // ]

    const [showStatusDropdown, setShowStatusDropdown] = useState(false);

    const statuses = [
        { label: "Trasmesso", value: "Transmitted" },
        { label: "Ricevuto", value: "Received" },
        { label: "In Transito", value: "In Transit" },
        { label: "Accettato", value: "Accepted" },
        { label: "Rifiutato", value: "Refused" },
    ];

    const statuses1 = [
        { label: "Tutti", value: "" },
        { label: "Trasmesso", value: "Transmitted" },
        { label: "Ricevuto", value: "Received" },
        { label: "In Transito", value: "In Transit" },
        { label: "Accettato", value: "Accepted" },
        { label: "Rifiutato", value: "Refused" },
    ];


    useEffect(() => {
        const role = localStorage.getItem("Role");
        setUserType(role)
    }, []);


    const allowedStatuses =
        userType === "admin"
            ? statuses
            : statuses.filter((status) =>
                [
                    // "In Transit",
                    "Accepted",
                    "Refused"
                ].includes(status.value)
            );

    const getOrdersData = async (statusFilter = "") => {
        setIsLoading(true);
        try {
            const params = {
                pageNumber: page,
                size: rowsPerPage,
                ...(statusFilter && { status: statusFilter }),
            };

            const response = await axios.get(
                `${apiUrl}/api/v1/restaurants/${rest_slug2}/orders`,
                {
                    params,
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            const data = response.data;

            const ordersWithStatus = data.data.map((order) => ({
                ...order,
                selectedStatus: order.status,
            }));

            setSelectedStatus(ordersWithStatus);
            setOrderData(data.data);
            setTotalPages(data.total);
        } catch (error) {
            console.error("Error fetching order data:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleStatusChange = (statusValue) => {
        setSelectedStatus1(statusValue);
        setPage(1);
        getOrdersData(statusValue);
        setShowStatusDropdown(false);
        setOpenDropdownId(null);
    };

    const getViewOrdersData = async () => {
        setIsLoading(true);
        try {
            const OrderId = selectedOrder.id;
            // Fetch order data
            const response = await axios.get(
                `${apiUrl}/api/v1/orders/${OrderId}/wines`,
                {
                    params: {
                        pageNumber: page,
                        size: rowsPerPage,
                    },
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            // Set order data response
            const data = response.data;
            setViewOrderData(data?.wines?.data || []);
            setTotalPages(data?.wines?.total);
        } catch (error) {
            console.error("Error fetching or updating order data:", error);
        } finally {
            setIsLoading(false);
        }
    };



    // Function to handle status selection
    // const handleStatusSelect = async (status, orderId) => {
    //     // console.log("Selected status:", status);
    //     // console.log("Order ID:", orderId);

    //     try {
    //         await axios.put(
    //             `${apiUrl}/api/v1/orders/${orderId}/status`,
    //             { status: status },
    //             {
    //                 headers: {
    //                     Authorization: `Bearer ${token}`,
    //                 },
    //             }
    //         );
    //         setOrderData((prevOrderData) =>
    //             prevOrderData.map((order) =>
    //                 order.id === orderId ? { ...order, status: status } : order
    //             )
    //         );
    //         setOpenDropdownId(null);
    //         // toast("Status Changed Successfully");
    //     } catch (error) {
    //         console.error("Error updating order status:", error);
    //     }
    // };

    const handleStatusSelect = async (status, orderId) => {
        try {
            const response = await axios.put(
                `${apiUrl}/api/v1/orders/${orderId}/status`,
                { status: status },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            setOrderData((prevOrderData) =>
                prevOrderData.map((order) =>
                    order.id === orderId ? { ...order, status: status } : order
                )
            );
            console.log(response?.data?.message);
            setOpenDropdownId(null);
            toast.success(response?.data?.message, {
                autoClose: 1000,
                theme: "colored",
            });
        } catch (error) {
            console.error("Error updating order status:", error);
        }
    };

    const handleViewOrderClick = (order) => {
        setSelectedOrder(order);
        setShowOrder(true);
    };

    const toggleDropdown = (orderId) => {
        setOpenDropdownId((prevOpenDropdownId) =>
            prevOpenDropdownId === orderId ? null : orderId
        );
        setShowStatusDropdown(false);
    };

    useImperativeHandle(ref, () => ({
        incomingOrder() {
            setShowOrder(false);
            setIsAddOrder(false);
            setIsEditing(false);
        },
    }));

    useEffect(() => {
        getOrdersData();
        if (selectedOrder) {
            getViewOrdersData();
        }
    }, [page, rowsPerPage, selectedOrder]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest(".dropdown-container")) {
                setOpenDropdownId(null);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleEditClick = (order) => {
        setIsEditing(true);
        setCurrentOrderData(order);
    };

    const handleCancel = () => {
        setIsEditing(false);
        setCurrentOrderData(null);
    };

    const handleDelete = async (id) => {
        if (!id) {
            console.error("Error: ID is required to delete a user.");
            return;
        }

        setIsLoading({ ...isLoading, main: true });

        try {
            const response = await axios.delete(
                `${apiUrl}/api/v1/restaurants/${rest_slug2}/orders/${id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            getOrdersData();
            toast.success(response?.data?.message || "Order deleted successfully:", {
                theme: "colored",
                autoClose: 1000,
            });
        } catch (error) {
            console.error(
                "Error deleting order:",
                error?.response?.data?.message || error.message
            );
            toast.error("Failed to delete the order. Please try again.", {
                theme: "colored",
                autoClose: 3000,
            });
        } finally {
            setIsLoading({ ...isLoading, main: false });
        }
    };

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (!event.target.closest(".dropdown-container")) {
                setShowStatusDropdown(false);
            }
        };
        document.addEventListener("click", handleOutsideClick);
        return () => {
            document.removeEventListener("click", handleOutsideClick);
        };
    }, []);

    return (
        <>
            <section className="border-t border-[#D9D9D9] mt-5 pt-5">
                {showOrder && selectedOrder ? (
                    <>
                        <div className="flex justify-between">
                            <div>
                                <h3 className="flex text-3xl font-bold mb-2 poppins-medium items-center">
                                    {/* <p className='text-lg font-light poppins-medium mr-6'>0{selectedOrder.id || 'N/A'} </p>  */}
                                    {selectedOrder?.order_number || "N/A"}
                                </h3>
                            </div>
                            <p className="text-lg font-normal poppins-medium mr-4">
                                {selectedOrder?.order_date ? (
                                    new Date(selectedOrder?.order_date)
                                        .toLocaleDateString("en-GB")
                                        .replace(/\//g, "-")
                                ) : (
                                    <span className="text-gray-400">N/A</span>
                                )}
                            </p>
                        </div>
                        {/* <div className=" dash-table-main w-auto h-auto bg-[#FBFBFB] border-[2px] border-[#8B24332B] px-6 pt-3 pb-0 rounded-xl shadow">
                            <table className="lg:w-full w-[700px] text-left wine_table">
                                <thead>
                                    <tr className="border-b border-[#8B2433]">
                                        <th className="pb-3 pr-2 text-left poppins-medium text-[#6B6B6B]">Immagine</th>
                                        <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">Nome</th>
                                        <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">Tipologia</th>
                                        <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">Nazione</th>
                                        <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">Prezzo</th>
                                        <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">IVA%</th>
                                        <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">Quantità</th>
                                        <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">Prezzo totale</th>
                                    </tr>
                                </thead>
                                {isLoading ? (
                                    <TableLoader />
                                ) : (
                                    <tbody>
                                        {Array.isArray(viewOrderData) && viewOrderData?.length > 0 ? (
                                            viewOrderData?.map((orderInfo, index) => (
                                                <tr key={index} className="border-b border-[#8B2433]/12">
                                                    <td className="pr-2 py-4">
                                                        <div className="thumbnail_image rounded-lg w-[50px] h-[60px] bg-white p-1 flex align-center justify-center">
                                                            <img
                                                                className="w-100 p-1 h-100 object-contain border border-[#68172394] rounded-lg"
                                                                src={
                                                                    orderInfo?.wine?.image && orderInfo?.wine?.image !== ""
                                                                        ? orderInfo?.wine?.image
                                                                        : defaultImage
                                                                }
                                                                height={50}
                                                                width={50}
                                                            />
                                                        </div>
                                                    </td>
                                                    <td className="py-4 px-2 text-left poppins-medium text-[#303030]">{orderInfo?.wine.name || 'N/A'}</td>
                                                    <td className="py-4 px-2 text-left poppins-medium text-[#303030]">{orderInfo?.wine.product_type || 'N/A'}</td>
                                                    <td className="py-4 px-2 text-left poppins-medium text-[#303030]">{orderInfo?.country || 'N/A'}</td>
                                                    <td className="py-4 px-2 text-left poppins-medium text-[#303030]">{orderInfo?.price ? `${orderInfo?.price} €` : 'N/A'}</td>
                                                    <td className="py-4 px-2 text-left poppins-medium text-[#303030]">22%</td>
                                                    <td className="py-4 px-2 text-left poppins-medium text-[#303030]">
                                                        <span className="inline-flex items-center justify-center bg-[#8B2433A6] text-white rounded-full min-w-[32px] h-[32px]">
                                                            {orderInfo?.bottles_quantity || 0}
                                                        </span>
                                                    </td>
                                                   

                                                    <td className="py-4 px-2 text-left poppins-medium text-[#303030]">
                                                        {orderInfo?.price && orderInfo?.bottles_quantity
                                                            ? (() => {
                                                                const basePrice = orderInfo?.price * orderInfo?.bottles_quantity;
                                                                const taxAmount = basePrice * 0.22;
                                                                const totalPrice = basePrice + taxAmount;
                                                                return `${totalPrice.toFixed(2)} €`;
                                                            })()
                                                            : 'N/A'}
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={9} className="text-center py-4">Nessun ordine trovato</td>
                                            </tr>
                                        )}
                                     
                                       

                                        <tr className="font-bold text-[#303030]">
                                            <td colSpan={6} className="text-right py-4 px-2 poppins-medium">Valore Cantina:</td>
                                            <td className="text-left py-4 px-2 poppins-medium">
                                                {Array.isArray(viewOrderData) && viewOrderData.length > 0
                                                    ? `${viewOrderData.reduce((sum, orderInfo) => {
                                                        const basePrice = orderInfo?.price ? orderInfo.price * orderInfo.bottles_quantity : 0;
                                                        const taxAmount = basePrice * 0.22;
                                                        return sum + basePrice + taxAmount;
                                                    }, 0).toFixed(2)} €`
                                                    : "N/A"}
                                            </td>
                                        </tr>
                                    </tbody>
                                )}
                            </table>

                        </div> */}

                        <OrderView viewOrderData={viewOrderData} isLoading={isLoading} />
                        {viewOrderData && viewOrderData?.length > 0 && (
                            <PaginationComponent
                                page={page}
                                totalPages={totalPages}
                                rowsPerPage={rowsPerPage}
                                setPage={setPage}
                                setRowsPerPage={setRowsPerPage}
                            />
                        )}
                    </>
                ) : (
                    <>
                        {IsAddOrder ? (
                            <OrderAdd
                                setIsAddOrder={setIsAddOrder}
                                getOrdersData={getOrdersData}
                            />
                        ) : isEditing ? (
                            <OrderEdit
                                handleCancel={handleCancel}
                                setIsEditing={setIsEditing}
                                getOrdersData={getOrdersData}
                                currentOrderData={currentOrderData}
                            />
                        ) : (
                            <>
                                <div className="flex lg:flex-row flex-col justify-between items-center mt-3 mb-3 w-full">
                                    <h3 className="text-3xl font-bold mb-2 poppins-medium self-start">
                                        Ordini In Entrata
                                    </h3>
                                    <div className="self-start flex items-center gap-4 sm:flex-row flex-col sm:w-auto w-full">
                                        <div className="flex flex-col md:w-[50%] w-full gap-3">
                                            <div className="flex flex-col w-full space-y-2 dropdown-container">
                                                <div className="relative group w-full min-w-[200px]">
                                                    {/* Increased minimum width */}
                                                    <button
                                                        className={`${showStatusDropdown
                                                            ? "border-b-0 rounded-tl-3xl rounded-tr-3xl"
                                                            : "rounded-full"
                                                            } border bg-[#fff] font-medium border-[#d5d6d9] inline-flex justify-between items-center w-full px-4 py-[10px] outline-none text-[#6B6B6B] shadow-sm relative z-30 text-xs h-[40px] transition-all duration-200`}
                                                        onClick={() =>
                                                            setShowStatusDropdown(!showStatusDropdown)
                                                        }
                                                    >
                                                        <span className="mr-2 flex items-center gap-3 poppins-medium">
                                                            {selectedStatus1
                                                                ? statuses1.find(
                                                                    (s) => s.value === selectedStatus1
                                                                )?.label || "Scegli Status"
                                                                : "Scegli Status"}
                                                        </span>
                                                        <RiArrowDownSLine
                                                            className={`transform transition-transform duration-300 ${showStatusDropdown ? "rotate-180" : ""
                                                                }`}
                                                            size={"24px"}
                                                            color="#9f414f"
                                                        />
                                                    </button>
                                                    <div
                                                        className={`${showStatusDropdown
                                                            ? "opacity-100 translate-y-0"
                                                            : "opacity-0 -translate-y-2 pointer-events-none"
                                                            } bg-[#FFFFFF] z-[999] h-[160px] border-[#d5d6d9] absolute rounded-b-3xl p-2 px-4 right-0 mt-0 shadow-lg text-[#DB7685] space-y-1 w-full border transition-all duration-300 ease-[cubic-bezier(0.4,0,0.2,1)] origin-top`}
                                                    >
                                                        <div className="max-h-[130px] overflow-y-auto btn-all-yscroll">
                                                            {statuses1.map((status) => (
                                                                <div
                                                                    className="flex gap-[20px] hover:bg-gray-100 px-2 py-1 rounded transition-colors duration-150"
                                                                    key={status.value}
                                                                    onClick={() =>
                                                                        handleStatusChange(status.value)
                                                                    }
                                                                >
                                                                    <label className="px-0 py-2 cursor-pointer flex justify-between flex-row gap-[15px] filter_list_btn">
                                                                        <input
                                                                            type="radio"
                                                                            className="outline-none cursor-pointer"
                                                                            checked={selectedStatus1 === status.value}
                                                                        />
                                                                    </label>
                                                                    <span className="text-xs text-[#8B8B8B] rounded-md flex items-center poppins-regular">
                                                                        {status.label}
                                                                    </span>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <button
                                            className="flex sm:w-auto w-full items-center justify-center px-6 py-[10px] bg-[#8A2533] text-white rounded-3xl border-2 border-[#953543] hover:text-[#8A2533] hover:bg-[#f6efef] transition-colors group h-[40px] min-w-[180px]"
                                            onClick={() => setIsAddOrder(true)}
                                        >
                                            <FaPlus />
                                            <span className="ml-2 poppins-regular text-xs">
                                                Aggiungi Ordini
                                            </span>
                                        </button>
                                    </div>
                                </div>
                                <div className="w-auto h-auto bg-[#FBFBFB] border-[2px] border-[#8B24332B] px-6 pt-3 pb-0 rounded-xl shadow overflow-x-auto">
                                    <table className="md:w-full w-[700px] text-left ">
                                        <thead>
                                            <tr className="border-b ">
                                                <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">
                                                    Sr.no
                                                </th>
                                                <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">
                                                    N.Ordine
                                                </th>
                                                <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">
                                                    Data Ordine
                                                </th>
                                                <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">
                                                    Stato Ordine
                                                </th>
                                                <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B] w-[14%]">
                                                    Azione
                                                </th>
                                                <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">
                                                    Opzioni
                                                </th>
                                            </tr>
                                        </thead>
                                        {isLoading ? (
                                            <TableLoader />
                                        ) : (
                                            <tbody>
                                                {orderData?.length ? (
                                                    orderData?.map((order, index) => {
                                                        const serialNumber = (page - 1) * rowsPerPage + index + 1;
                                                        return (
                                                            <tr
                                                                key={order.id}
                                                                className="border-b border-[#8B2433]/12"
                                                            >
                                                                <td className="py-4 px-2 text-left poppins-medium text-[#303030]">
                                                                    {/* 0{order?.id} */}
                                                                    {serialNumber}
                                                                </td>
                                                                <td className="py-4 px-2 text-left poppins-medium text-[#303030]">
                                                                    {order?.order_number}
                                                                </td>
                                                                <td className="py-4 px-2 text-left poppins-medium text-[#303030]">
                                                                    {order?.order_date ? (
                                                                        new Date(order.order_date)
                                                                            .toLocaleDateString("en-GB")
                                                                            .replace(/\//g, "-")
                                                                    ) : (
                                                                        <span className="text-gray-400">N/A</span>
                                                                    )}
                                                                </td>

                                                                {/* <td className="py-4 px-0 w-[14%]">
                                                            <div className="relative group w-auto bg-[#FFFFFF] dropdown-container">
                                                                <div className="border border-gray-300 rounded-3xl">
                                                                    <div
                                                                        onClick={() => toggleDropdown(order?.id)}
                                                                        className="flex justify-between items-center w-full px-4 lg:py-3 py-1 text-xs text-[#8B8B8B] rounded-3xl bg-transparent cursor-pointer relative z-10"
                                                                    >
                                                                        <span className="mr-2 flex items-center gap-3 poppins-medium">

                                                                            {order?.status === "Transmitted"
                                                                                ? "Trasmesso"
                                                                                : order?.status === "Received"
                                                                                    ? "Ricevuto"
                                                                                    : order?.status === "In Transit"
                                                                                        ? "In Transito"
                                                                                        : order?.status === "Accepted"
                                                                                            ? "Accettato"
                                                                                            : order?.status === "Refused"
                                                                                                ? "Rifiutato"
                                                                                                : order?.status || "Select Status"}
                                                                        </span>
                                                                        <RiArrowDownSLine />
                                                                    </div>
                                                                </div>
                                                                {openDropdownId === order?.id && (
                                                                    <div className="z-[50] absolute bg-[#FFFFFF] top-14 p-2 px-4 mt-0 rounded-[21px] shadow-lg text-[#DB7685] space-y-1 w-full transition-all duration-300 ease-in-out">
                                                                        {statuses
                                                                            .filter(
                                                                                (status) =>
                                                                                    status.value !== order?.status
                                                                            )
                                                                            .map((status, index, array) => (
                                                                                <label
                                                                                    key={status}
                                                                                    className={`${index !== array.length - 1
                                                                                        ? "border-b border-[#8b24331f]"
                                                                                        : ""
                                                                                        } px-0 py-2 cursor-pointer flex justify-between flex-row gap-[15px] filter_list_btn`}
                                                                                    onClick={() =>
                                                                                        handleStatusSelect(
                                                                                            status.value,
                                                                                            order?.id
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    <span className="text-xs text-[#8B8B8B] rounded-md flex items-center gap-3 poppins-regular">
                                                                                        {status.label}
                                                                                    </span>
                                                                                </label>
                                                                            ))}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </td> */}

                                                                <td className="py-4 px-0 w-[14%]">
                                                                    <div className="text-red-700 gap-4 flex items-center justify-start">
                                                                        {userType === "restaurant" &&
                                                                            (order?.status === "Transmitted" || order?.status === "Received") ? (
                                                                            <Menu>
                                                                                <MenuButton className="flex items-center justify-between gap-3 lg:py-[10px] text-[#8B8B8B] text-xs poppins-medium border border-gray-300 rounded-3xl px-4 py-1 w-full cursor-not-allowed">
                                                                                    <span className="text-[#8B8B8B] text-xs poppins-medium">
                                                                                        {order?.status === "Transmitted"
                                                                                            ? "Trasmesso"
                                                                                            : order?.status === "Received"
                                                                                                ? "Ricevuto"
                                                                                                : order?.status}
                                                                                    </span>
                                                                                </MenuButton>
                                                                            </Menu>
                                                                        ) : (
                                                                            <Menu>
                                                                                <MenuButton className="flex items-center justify-between gap-3 lg:py-[10px] text-[#8B8B8B] text-xs poppins-medium border border-gray-300 rounded-3xl px-4 py-1 cursor-pointer w-full">
                                                                                    <span>
                                                                                        {order?.status === "Transmitted"
                                                                                            ? "Trasmesso"
                                                                                            : order?.status === "Received"
                                                                                                ? "Ricevuto"
                                                                                                : order?.status === "In Transit"
                                                                                                    ? "In Transito"
                                                                                                    : order?.status === "Accepted"
                                                                                                        ? "Accettato"
                                                                                                        : order?.status === "Refused"
                                                                                                            ? "Rifiutato"
                                                                                                            : order?.status || "Select Status"}
                                                                                    </span>
                                                                                    <RiArrowDownSLine size={"18px"} />
                                                                                </MenuButton>

                                                                                <MenuItems
                                                                                    anchor="bottom"
                                                                                    className="bg-[#fff] px-[16px] py-[8px] mt-[10px] max-w-full lg:w-[11%] w-[150px] text-black  flex flex-col gap-2 shadow-2xl rounded-3xl relative"
                                                                                >
                                                                                    <div className="absolute -top-2 left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-8 border-r-8 border-b-8 border-l-transparent border-r-transparent border-b-white"></div>

                                                                                    {allowedStatuses
                                                                                        .filter(status => status.value !== order?.status)
                                                                                        .map((status, index, array) => (
                                                                                            <MenuItem
                                                                                                key={status.value}
                                                                                                className={`${index !== array.length - 1
                                                                                                    ? "border-b border-[#8b24331f]"
                                                                                                    : ""
                                                                                                    } px-0 py-2`}
                                                                                            >
                                                                                                <button
                                                                                                    onClick={() =>
                                                                                                        handleStatusSelect(
                                                                                                            status.value,
                                                                                                            order?.id
                                                                                                        )
                                                                                                    }
                                                                                                    className={`px-0 py-2 justify-between flex-row gap-[15px] filter_list_btn border-b hover:border-[#8b2433] border-[#8b24331f] w-full text-left ${userType === "restaurant" &&
                                                                                                        order?.status === "Accepted" &&
                                                                                                        status.value === "Refused"
                                                                                                        ? "text-gray-400 cursor-not-allowed"
                                                                                                        : "cursor-pointer hover:text-[#8b2433]"
                                                                                                        }`}
                                                                                                    disabled={
                                                                                                        userType === "restaurant" &&
                                                                                                        order?.status === "Accepted" &&
                                                                                                        status.value === "Refused"
                                                                                                    }
                                                                                                >
                                                                                                    {status.label}
                                                                                                </button>
                                                                                            </MenuItem>
                                                                                        ))}
                                                                                </MenuItems>
                                                                            </Menu>
                                                                        )}
                                                                    </div>
                                                                </td>
                                                                <td className="py-4 px-7 text-left poppins-medium text-[#303030]">
                                                                    <button
                                                                        onClick={() => {
                                                                            handleViewOrderClick(order);
                                                                        }}
                                                                    >
                                                                        Visualizza ordine
                                                                    </button>
                                                                </td>

                                                                <td className="py-4 px-2">
                                                                    <button
                                                                        className="mx-2 text-red-700"
                                                                        onClick={() => {
                                                                            setDialog(true);
                                                                            setSelectedOrderId(order.id);
                                                                        }}
                                                                    >
                                                                        <BiSolidTrashAlt size={"18px"} />
                                                                    </button>
                                                                    {dialog && (
                                                                        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-20 z-50">
                                                                            <div className="bg-white rounded-lg shadow-lg sm:w-1/3 w-[280px]">
                                                                                <div className="px-6 py-4 border-b">
                                                                                    <h3 className="text-lg font-semibold text-gray-800 poppins-medium">
                                                                                        Are you sure you want to delete the
                                                                                        order?
                                                                                    </h3>
                                                                                </div>
                                                                                <div className="px-6 py-4 flex justify-end space-x-4">
                                                                                    <button
                                                                                        onClick={() => {
                                                                                            handleDelete(selectedOrderId);
                                                                                            setDialog(false);
                                                                                        }}
                                                                                        className="px-4 py-2 poppins-regular bg-[#8A2533] text-white rounded-md hover:bg-[#f6efef] hover:text-[#8A2533] transition-colors"
                                                                                    >
                                                                                        Yes
                                                                                    </button>
                                                                                    <button
                                                                                        onClick={() => setDialog(false)}
                                                                                        className="px-4 py-2 poppins-regular bg-gray-300 text-gray-700 rounded-md hover:text-white hover:bg-[#8A2533] transition-colors"
                                                                                    >
                                                                                        No
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td colSpan={9} className="text-center py-4">
                                                            Nessun ordine trovato
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        )}
                                    </table>
                                </div>
                            </>
                        )}
                    </>
                )}
            </section>
        </>
    );
};

export default forwardRef(OrderManagement);